export default __webpack_public_path__ + "static/media/download-icon.9f7c2108.svg";